import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api"; // Ensure these methods are implemented

function UserRoleList() {
  const token = localStorage.getItem("token");
  const [userData, setUserData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [roles, setRoles] = useState([]);

  const modalStyles = {
    display: "flex",
    position: "fixed",
    zIndex: 1000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
    width: "400px",
    maxWidth: "90%",
  };

  const getUsers = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetUsers", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUserData(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const getRoles = async (user) => {
    if (!token) return;
    const formData = { Id: user.id }; // Adjust based on your needs
    try {
      const response = await post(
        "UserAuthentication/GetAssignedRoles",
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setRoles(response); // Assuming response structure is correct
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const handleAssignRoles = async () => {
    if (!currentUser) return;

    // Prepare the roles payload based on checkbox states
    const formData = {
      UserId: currentUser.id,
      Roles: roles.map((role) => ({
        RoleId: role.id,
        Status: !role.isDeleted, // Set Status based on isDeleted (checked if isDeleted is false)
      })),
    };

    try {
      await post("UserAuthentication/AssignRoles", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      alert("Roles Assigned to user");
      setModalOpen(false);
      getUsers(); // Refresh the user list after assignment
    } catch (error) {
      console.error("Error assigning roles:", error);
    }
  };

  const handleOpenModal = (user) => {
    setCurrentUser(user);
    getRoles(user);
    setModalOpen(true);
  };

  useEffect(() => {
    getUsers();
  }, []);

  const columns = [
    {
      name: "UserName",
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-outline-primary py-1 px-2 lh-2"
          onClick={() => handleOpenModal(row)}
        >
          Assign Roles
        </button>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <>
      <DataTable columns={columns} data={userData} pagination dense />

      {modalOpen && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h2>Assign Roles to {currentUser?.username}</h2>
            {roles.map((role) => (
              <div key={role.id}>
                <input
                  type="checkbox"
                  checked={!role.isDeleted} // Check if isDeleted is false
                  onChange={() => {
                    setRoles((prevRoles) =>
                      prevRoles.map((r) =>
                        r.id === role.id
                          ? { ...r, isDeleted: !r.isDeleted } // Toggle isDeleted
                          : r
                      )
                    );
                  }}
                />
                <label>{role.name}</label>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={handleAssignRoles}
                className="btn btn-outline-success"
                style={{ marginRight: "10px" }}
              >
                Save
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn btn-outline-secondary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UserRoleList;
